import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class UserManagementServe {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 分页查询所有用户数据
  public sysAllUserList(opts: object) {
    const url = serverUrl + '/api/user/list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addUserData(opts: object) {
    const url = serverUrl + '/api/user/register';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 修改数据
  public editUserData(opts: object) {
    const url = serverUrl + '/api/user/updateUser';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改密码
  public editPasswordData(opts: object) {
    const url = serverUrl + '/api/user/updatePassword' + changePostParam(opts);
    return this.rSerivce.serverObj.post(url);
  }

  // 删除用户数据
  public deleteUserData(id: any) {
    const url = serverUrl + '/api/user?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 根据账号用户用户信息
  public getInfoByAccount(account: string) {
    const url = serverUrl + '/api/user/getByAccount';
    return this.rSerivce.serverObj.get(url, {
      params: {
        account: account,
      },
    });
  }
  // id查询用户信息
  public getUserInfoById(id: any) {
    const url = serverUrl + '/api/user/entity/id/' + id;
    return this.rSerivce.serverObj.get(url);
  }
}
